const getTokenFromCookie = () => {
  const token = document.cookie
    .split('; ')
    .find(row => row.startsWith('accessToken='))
    ?.split('=')[1];
  return token || null;
};

export const decodeJwt = (token) => {
  try {
    if (!token) return null;
    
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export const isOrgMemberFromToken = () => {
  const token = getTokenFromCookie();
  if (!token) return false;
  
  const decoded = decodeJwt(token);
  if (!decoded) return false;
  
  return decoded.isOrgUser === true && decoded.accountType !== 'organization';
};

export const getTokenPayload = () => {
  const token = getTokenFromCookie();
  if (!token) return null;
  
  return decodeJwt(token);
};
